import axios from "axios";
import { API } from "../utilities/api.config";

function saveCustodians(data) {
  const request = () =>
    axios.post(API.UPDATE_CUSTODIANS, data, {
      headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
    });
  return (dispatch) => {
    dispatch({
      type: "CUSTODIAN_UPDATE_REQUESTED",
    });
    request()
      .then((response) => {
        dispatch({
          type: "CUSTODIAN_UPDATE_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "CUSTODIAN_UPDATE_FAIL",
          payload: error,
        });
      });
  };
}

export default {
  saveCustodians,
};



// WEBPACK FOOTER //
// ./src/actions/custodian.action.js